<template>
    <div>
        <v-container>
            <v-row class="overlay-menu-row">
                <v-col v-for="n in getEntries" :key="n.title" cols="12" sm="6" md="3" class="d-flex">
                    <router-link style="text-decoration: none; color: inherit; width: 100%;" :to="n.link"
                        @click.native="$store.state.main.menuoverlay = false">
                        <v-hover v-slot="{ hover }">
                            <v-card flat class="overlay-menu-item pa-5" :class="{ 'overlay-menu-item--hover': hover }">
                                <div class="overlay-menu-item__icon mb-3">
                                    <v-icon :color="hover ? '#b40055' : '#281e78'" size="28">{{ n.symbol }}</v-icon>
                                </div>
                                <div class="overlay-menu-item__title" :style="{ 'color': hover ? '#b40055' : '#22262f' }">
                                    {{ n.title }}
                                </div>
                                <div class="overlay-menu-item__info" v-if="n.info">
                                    {{ n.info }}
                                </div>
                            </v-card>
                        </v-hover>
                    </router-link>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import router from "@/router";
export default {
    name: "overlayMenu",
    props: ["category"],
    data() {
        return {
        }
    },
    methods: {

    },
    computed: {
        getEntries() {
            const routes = router.options.routes
            let categories = {}
            let permissions=this.$store.state.auth.authClaims.permissions
            for (let route of routes) {
                if (route.meta && route.meta.showInDrawer && route.meta.showInDrawer === true && route.meta.category != undefined) {
                    if (!route.meta.requiresAuth || (route.meta.requiresAuth && this.$store.state.auth && this.$store.state.auth.isSignedIn)) {
                        if (permissions[route.meta.permission] === true) {
                            if (categories[route.meta.category] == undefined) {
                                categories[route.meta.category] = []
                            }
                            categories[route.meta.category].push({
                                link: route.path,
                                title: route.meta.title,
                                symbol: route.meta.symbol,
                                info: route.meta.info
                            })
                        }
                    }
                }
            }
            return categories[this.category]
        },
        isSignedIn() {
            return this.$store.state.auth.isSignedIn
        },
    },
    watch: {
    },
    mounted() {

    }
}
</script>

<style scoped>
.overlay-menu-row {
    align-items: stretch;
}

.overlay-menu-item {
    background: transparent !important;
    border-radius: 8px !important;
    transition: all 0.2s ease;
    cursor: pointer;
    box-shadow: none !important;
    height: 100%;
    min-height: 140px;
    display: flex;
    flex-direction: column;
}

.overlay-menu-item--hover {
    background: rgba(255, 255, 255, 0.06) !important;
}

.overlay-menu-item__icon {
    width: 48px;
    height: 48px;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
}

.overlay-menu-item__title {
    font-family: 'Geometria', Arial, sans-serif;
    font-weight: 700;
    font-size: 16px;
    color: #22262f;
    margin-bottom: 5px;
    transition: color 0.2s ease;
}

.overlay-menu-item__info {
    font-family: 'Geometria', Arial, sans-serif;
    font-weight: 400;
    font-size: 13px;
    color: rgba(34, 38, 47, 0.6);
    line-height: 1.4;
}
</style>